// NOTE: this is a SECOND API base URL, independent of API_URL in
// components/utils/axiosinstace.js. Login and several pages use this one, so
// BOTH must be flipped together when pointing the app at a local API.
export const env = {
    // Same variable as axiosinstace.js, so one env setting moves both.
    // Unset -> the deployed server, exactly as before.
    //   local: REACT_APP_API_BASE_URL=http://localhost:5555/api/v1
    produrl: process.env.REACT_APP_API_BASE_URL || "https://ipoultry.digiterrain.live/api/v1"
    //produrl: "https://digiterrain.live/api/v1"
    //produrl: "http://64.227.151.117:5000/api/v1"
}